import * as types from "../actions/actionType";

const initialState = {
	statuses: [],
};

export default function statusReducer(state = initialState, action) {
	const { type, payload } = action;
	let newState = {};
	switch (type) {
		case types.FETCH_ALL_STATUSES:
			newState = {
				...state,
				statuses: payload,
			};
			return newState;
		default:
			return state;
	}
}
